import React from 'react'
import { FastField } from 'formik'
import FormikInput from '../FormikInput'
import FormikCheckbox from '../FormikCheckbox'
import { FilterData } from './AppUserFilterDrawer'

type AppUserFilterFormProps = {
  isSubmitting: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  values: FilterData
}

const AppUserFiltersForm: React.FC<AppUserFilterFormProps> = ({ isSubmitting, setFieldValue, values }) => {
  return (
    <div className="px-4 divide-y divide-gray-200 sm:px-6">
      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <p className="text-base leading-6 font-semibold mb-2">Role</p>

        <FastField
          name="status"
          onChange={() => {
            setFieldValue('status', values.status === 'ACTIVE' ? '' : 'ACTIVE')
          }}
          component={FormikCheckbox}
          label="Active"
          checked={values.status && values.status === 'ACTIVE'}
        />

        <FastField
          name="status"
          onChange={() => {
            setFieldValue('status', values.status === 'INACTIVE' ? '' : 'INACTIVE')
          }}
          component={FormikCheckbox}
          label="Inactive"
          checked={values.status && values.status === 'INACTIVE'}
        />
      </fieldset>

      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <FastField type="text" name="area" component={FormikInput} label="Area" placeholder="Type Area name" />
      </fieldset>

      <fieldset className="space-y-6 pt-6 pb-5" disabled={isSubmitting}>
        <p className="text-base leading-6 font-semibold mb-2">Number of Experiences Shared</p>
        <div className="flex gap-5">
          <FastField
            type="number"
            name="nbSharedExperiences_gte"
            component={FormikInput}
            label="From"
            placeholder="0"
          />
          <FastField
            type="number"
            name="nbSharedExperiences_lte"
            component={FormikInput}
            label="To"
            placeholder="1000"
          />
        </div>
      </fieldset>
    </div>
  )
}

export default AppUserFiltersForm
